import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
// Import our Tailwind styles into the app
import "./scss/app.scss";

import { del, get, patch, post, put } from "./axios";
import { getAxiosErrorMessage, responseIsSuccessful } from "./global-helpers";
import { generateGoogleMapsUrl, underSlugify } from "./helpers";
// Import VueMQ
import VueMQ from "vue-mq";
// Import vue-unique-id
import UniqueId from "vue-unique-id";
// Import VueMoment
import Moment from "vue-moment";

Vue.use(VueMQ, {
  breakpoints: {
    sm: 767,
    md: 1023,
    lg: 1279,
    xl: Infinity
  }
});

Vue.use(UniqueId);

Vue.use(Moment);

Vue.mixin({
  methods: {
    get,
    post,
    del,
    put,
    patch,
    getAxiosErrorMessage,
    responseIsSuccessful,
    underSlugify,
    generateGoogleMapsUrl
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
